module.exports = __webpack_public_path__ + "static/media/SaveTime.2f13768d.svg";